<template>
  <v-app id="inspire">
    <v-content>
      <v-container fluid>
        <v-layout align-center justify-center>
          <!--Vertical y horizontal-->
          <v-flex xs12 sm8 md10>
            <v-card class="elevation-12">
              <v-toolbar dark color="primary">
                <v-toolbar-title>Registrar nuevo edificio</v-toolbar-title>
              </v-toolbar>
              <v-stepper v-model="buildingStepper">
                <v-stepper-header>
                  <v-stepper-step :complete="buildingStepper > 1" step="1">
                    Introducir datos
                  </v-stepper-step>

                  <v-divider></v-divider>

                  <v-stepper-step :complete="buildingStepper > 1" step="2">
                    Edificio creado
                  </v-stepper-step>

                  <v-divider></v-divider>

                  <v-stepper-step :complete="buildingStepper > 3" step="3">
                    Agregar sensores
                  </v-stepper-step>

                  <v-divider></v-divider>

                  <v-stepper-step :complete="buildingStepper > 4" step="4">
                    Agregar ubicación
                  </v-stepper-step>

                  <v-divider></v-divider>

                  <v-stepper-step :complete="buildingStepper >= 5" step="5">
                    Finalizar
                  </v-stepper-step>
                </v-stepper-header>

                <v-stepper-items>
                  <v-stepper-content step="1">
                    <form @submit.prevent="createBuilding">
                      <v-card class="mb-5" flat>
                        <v-text-field
                          required
                          outline
                          autofocus
                          id="name"
                          name="name"
                          label="Nombre del edificio"
                          append-icon="location_city"
                          v-model="name"
                          type="text"
                          counter
                          maxlength="70"
                        ></v-text-field>
                        <v-textarea
                          flat
                          auto-grow
                          outline
                          name="description"
                          label="Descripción (opcional)"
                          append-icon="description"
                          v-model="description"
                          counter
                          maxlength="500"
                        ></v-textarea>
                      </v-card>

                      <v-btn
                        color="primary"
                        type="submit"
                      >
                        Crear
                      </v-btn>
                    </form>
                  </v-stepper-content>

                  <v-stepper-content step="2">
                    <v-card class="mb-5" flat>
                      <v-card-title class="title" primary-title>
                        <h1>Edificio creado</h1>
                      </v-card-title>
                      <v-card-text>
                        El edificio
                        <ProfileLink
                          style="font-weight: bold"
                          :key="key"
                          v-bind:idKey="key"
                          type="building"
                        ></ProfileLink>
                        está registrado y listo para agregar sensores.
                        <br />
                        A continuación, puedes añadir sensores al edificio o
                        editarlo más adelante.
                      </v-card-text>
                      <v-card-actions>
                        <v-btn @click="buildingStepper = 3" color="primary">
                          Continuar
                        </v-btn>
                        <v-btn to="/dashboard/buildings" outline>
                          Ver lista de edificios
                        </v-btn>
                      </v-card-actions>
                    </v-card>
                  </v-stepper-content>

                  <v-stepper-content step="3">
                    <v-card class="mb-5" flat>
                      <v-card-title class="title" primary-title>
                        <h1>Agregar sensores</h1>
                      </v-card-title>
                      <v-card-text>
                        Selecciona los sensores que deses añadir o
                        <v-btn @click="buildingStepper = 4" color="primary">
                          Continuar
                        </v-btn>
                      </v-card-text>
                      <AddSensors
                        v-on:sensorsAdded="onSensorsAdded"
                        v-if="buildingStepper === 3"
                        v-bind:idKey="key"
                        tabla="buildings"
                      ></AddSensors>
                    </v-card>
                  </v-stepper-content>

                  <v-stepper-content step="4">
                    <v-card class="mb-5" flat>
                      <v-card-title class="title" primary-title>
                        <h1>Agregar ubicación</h1>
                      </v-card-title>
                      <v-card-text>
                        <h2>
                          Introduce una ubicación y comprueba en el mapa o
                          <v-btn @click="buildingStepper = 5" color="primary">
                            Continuar
                          </v-btn>
                        </h2>
                      </v-card-text>
                      <AddLocation
                        v-on:locationAdded="onLocationAdded"
                        v-if="buildingStepper === 4"
                        v-bind:idKey="key"
                      />
                    </v-card>
                  </v-stepper-content>

                  <v-stepper-content step="5">
                    <v-card class="mb-5" flat>
                      <v-card-title class="title" primary-title>
                        <h1>Fin</h1>
                      </v-card-title>
                      <v-card-text>
                        Has terminado de editar el edificio <b>{{ name }}</b>.
                      </v-card-text>
                      <v-card-actions>
                        <v-btn
                          :to="'/dashboard/buildings/building?id=' + key"
                          color="primary"
                        >
                          Ver edificio
                        </v-btn>
                        <v-btn to="/dashboard/buildings" outline>
                          Ver lista de edificios
                        </v-btn>
                      </v-card-actions>
                    </v-card>
                  </v-stepper-content>
                </v-stepper-items>
              </v-stepper>
            </v-card>
          </v-flex>
        </v-layout>
      </v-container>
    </v-content>
  </v-app>
</template>

<script>
import ProfileLink from "@/components/links/ProfileLink.vue";
import AddLocation from "@/components/AddLocation.vue";
import AddSensors from "@/components/AddSensors.vue";

//Página para registrar nuevos edificios
// @group Crear objetos
export default {
  components: {
    ProfileLink,
    AddLocation,
    AddSensors
  },
  data() {
    return {
      name: "",
      description: "",
      buildingStepper: 1,
      loader: null,
      loading: false,
      key: ""
    };
  },
  methods: {
    // @vuese
    // Crear un edificio
    // @arg Nombre, descripción y usuario
    createBuilding() {
      this.$store
        .dispatch("createBuilding", {
          name: this.name.trim(),
          description: this.description.trim(),
          owner: this.$store.state.user.uid
        })
        .then(valor => {
          this.key = valor;
          this.buildingStepper = 2;
        });
    },
    // @vuese
    // Cuando se añade una ubicación, avanzar al siguiente paso.
    onLocationAdded(value) {
      if (value === true) {
        this.buildingStepper = 5;
      }
    },
    // @vuese
    // Cuando se añaden sensores, avanzar al siguiente paso.
    onSensorsAdded(value) {
      if (value === true) {
        this.buildingStepper = 4;
      }
    }
  },
  watch: {
    loader() {
      const l = this.loader;
      this[l] = !this[l];

      setTimeout(() => (this[l] = false), 3000);

      this.loader = null;
      this.buildingStepper = 4;
    }
  }
};
</script>

<style>
.custom-loader {
  animation: loader 1s infinite;
  display: flex;
}
@-moz-keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}
@-webkit-keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}
@-o-keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}
@keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}
</style>
